import './component.scss'

import { Controller } from 'stimulus'

const application = window.Stimulus

application.register(
  'nurikae-site-pages-examples-index-partials-sticky-header',
  class extends Controller {
    static targets = ['header']

    connect () {
      this.observer = null

      // 事例一覧ページ用のトリガー要素を取得
      this.triggerElement = document.querySelector('.examples-index-sp__header')

      if (this.triggerElement) {
        this.setupObserver()
      }
    }

    disconnect () {
      if (this.observer) {
        this.observer.disconnect()
      }
    }

    setupObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
      }

      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options)
      this.observer.observe(this.triggerElement)
    }

    /**
     * examples-index-sp__headerが画面内外に移動したときに呼び出されるコールバック
     * @param {IntersectionObserverEntry[]} entries
     */
    handleIntersection (entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // examples-index-sp__headerが画面外に出たら表示
          this.showHeader()
        } else {
          // examples-index-sp__headerが画面内に入ったら非表示
          this.hideHeader()
        }
      })
    }

    showHeader () {
      this.headerTarget.classList.add('company-sp-sticky-header--visible')
    }

    hideHeader () {
      this.headerTarget.classList.remove('company-sp-sticky-header--visible')
    }
  }
)
